export enum RecommendationCopyKeys {
    CREATE_TITLE = 'createTitle',
    EDIT_TITLE = 'editTitle',
    SUBMIT_CREATE = 'submitCreate',
    SUBMIT_EDIT = 'submitEdit',
    DELETE_TITLE = 'deleteTitle',
    DELETE_MESSAGE = 'deleteMessage',
    CREATE_SUCCESS = 'createSuccess',
    UPDATE_SUCCESS = 'updateSuccess',
    DELETE_SUCCESS = 'deleteSuccess',
    CREATE_ERROR = 'createError',
    UPDATE_ERROR = 'updateError',
    DELETE_ERROR = 'deleteError',
}

const RECOMMENDATION_COPY: Record<RecommendationCopyKeys, string> = {
    [RecommendationCopyKeys.CREATE_TITLE]: 'Create recommendation',
    [RecommendationCopyKeys.EDIT_TITLE]: 'Edit recommendation',
    [RecommendationCopyKeys.SUBMIT_CREATE]: 'Create',
    [RecommendationCopyKeys.SUBMIT_EDIT]: 'Confirm',
    [RecommendationCopyKeys.DELETE_TITLE]: 'Delete recommendation?',
    [RecommendationCopyKeys.DELETE_MESSAGE]:
        'This recommendation will be removed from the CMS.',
    [RecommendationCopyKeys.CREATE_SUCCESS]:
        'Recommendation created successfully!',
    [RecommendationCopyKeys.UPDATE_SUCCESS]:
        'Recommendation edited successfully!',
    [RecommendationCopyKeys.DELETE_SUCCESS]:
        'Successfully deleted the recommendation.',
    [RecommendationCopyKeys.CREATE_ERROR]:
        'There was an error creating the recommendation',
    [RecommendationCopyKeys.UPDATE_ERROR]:
        'There was an error editing the recommendation',
    [RecommendationCopyKeys.DELETE_ERROR]:
        'There was an error deleting the recommendation',
};

export const createRecommendationCopy = (itemKey: RecommendationCopyKeys) =>
    RECOMMENDATION_COPY[itemKey];
